<template>
  <div class="download-version">
    <b-img src="../../assets/makerbot_pic.jpg" fluid></b-img>
    <b-card>
      <b-card-text>
        <b-container fluid>
          <b-row>
            <b-col cols="8">
              <h3>Cloud Client for Makerbot</h3>
              <a href="https://docs.google.com/document/d/1PO1XPZndOOCyMXlnTqVlEgkmZplIPm3t123VpQdu0OE/edit" target="_blank">3DPrinterOS on Makerbot installation guide v2.4</a>
            </b-col>
            <b-col cols="4" style="text-align: right">
              <b-img src="../../assets/makerbot_logo.png"></b-img>
            </b-col>
          </b-row>
        </b-container>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: 'makerbot-client-installation',
  }
</script>